import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuppliersService, Supplier } from '../../services/suppliers.service';

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.css']
})
export class SuppliersComponent implements OnInit {
  displayedColumns: string[] = ['id', 'supplierCode', 'name', 'contactPerson', 'email', 'phone', 'city', 'status', 'totalOrders', 'totalValue', 'lastOrderDate', 'actions'];
  dataSource = new MatTableDataSource<Supplier>();
  isLoading = false;
  totalSuppliers: number = 0;
  activeSuppliers: number = 0;
  totalOrders: number = 0;
  totalValue: number = 0;

  constructor(
    private suppliersService: SuppliersService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.loadSuppliers();
  }

  loadSuppliers(): void {
    this.isLoading = true;
    this.suppliersService.getSuppliers().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource.data = response.data;
          this.calculateTotals();
        } else {
          this.snackBar.open(response.message || 'Failed to load suppliers', 'Close', { duration: 3000 });
        }
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading suppliers:', error);
        this.snackBar.open('Error loading suppliers', 'Close', { duration: 3000 });
        this.isLoading = false;
      }
    });
  }

  calculateTotals(): void {
    this.totalSuppliers = this.dataSource.data.length;
    this.activeSuppliers = this.dataSource.data.filter(item => item.status === 'Active').length;
    this.totalOrders = this.dataSource.data.reduce((sum, item) => sum + item.totalOrders, 0);
    this.totalValue = this.dataSource.data.reduce((sum, item) => sum + item.totalValue, 0);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  addSupplier(): void {
    this.snackBar.open('Add supplier feature coming soon', 'Close', { duration: 3000 });
    // TODO: Implement add supplier dialog
  }

  editSupplier(supplier: Supplier): void {
    this.snackBar.open(`Edit ${supplier.name} feature coming soon`, 'Close', { duration: 3000 });
    // TODO: Implement edit supplier dialog
  }

  viewSupplierDetails(supplier: Supplier): void {
    this.snackBar.open(`Viewing details for ${supplier.name}`, 'Close', { duration: 3000 });
    // TODO: Implement supplier details dialog
  }

  toggleSupplierStatus(supplier: Supplier): void {
    const newStatus = supplier.status === 'Active' ? 'Inactive' : 'Active';
    this.snackBar.open(`${supplier.name} status changed to ${newStatus}`, 'Close', { duration: 3000 });
    // TODO: Implement status toggle with API call
  }

  deleteSupplier(supplier: Supplier): void {
    this.snackBar.open(`Deleting ${supplier.name}...`, 'Close', { duration: 3000 });
    // TODO: Implement delete supplier with confirmation
  }

  exportToExcel(): void {
    this.snackBar.open('Exporting to Excel...', 'Close', { duration: 3000 });
    this.suppliersService.exportToExcel().subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `suppliers-${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.snackBar.open('Excel export completed', 'Close', { duration: 3000 });
      },
      error: (error) => {
        console.error('Error exporting to Excel:', error);
        this.snackBar.open('Error exporting to Excel', 'Close', { duration: 3000 });
      }
    });
  }

  exportToPDF(): void {
    this.snackBar.open('Exporting to PDF...', 'Close', { duration: 3000 });
    this.suppliersService.exportToPDF().subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `suppliers-${new Date().toISOString().split('T')[0]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.snackBar.open('PDF export completed', 'Close', { duration: 3000 });
      },
      error: (error) => {
        console.error('Error exporting to PDF:', error);
        this.snackBar.open('Error exporting to PDF', 'Close', { duration: 3000 });
      }
    });
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'Active': return 'badge-success';
      case 'Inactive': return 'badge-danger';
      case 'Pending': return 'badge-warning';
      default: return 'badge-secondary';
    }
  }
}
